import './styles/theme.scss'

import log from './lib/salvo-lite/log'
import context from './lib/salvo-lite/context'
import Theme from './scripts/Theme'

import 'dom4'

context.setTemplate(window.SALVO_BINDINGS.template)

var theme = new Theme()

theme.registerComponents()
theme.registerPages()

log.debug('Main', 'Ready!')



// WEBPACK FOOTER //
// ./resources/main.js